import { formatString } from "@@common";
import React from "react";
import { Link } from "react-router-dom";
import { TableColumnModel } from "../../Models/TableModel";
import { formatColumnValue } from "./formatColumnValue";

type ColumnActionsProps = {
  column: TableColumnModel;
  row: Record<string, any>;
};

const ColumnActions: React.FC<ColumnActionsProps> = ({ column, row }) => {
  return (
    <>
      {column.ValueTemplate && formatColumnValue(row, column)}
      {column.Actions?.map((action, index) => (
        <React.Fragment key={index}>
          {index > 0 && " | "}
          <Link to={action.Path ? formatString(action.Path, row) : "#"} style={{ textDecoration: "none" }}>
            {action.Label}
          </Link>
        </React.Fragment>
      ))}
    </>
  );
};

export default ColumnActions;
